import CustomRobotGreen from 'assets/images/icons/CustomRobotGreen.svg'
import NoPendingDispositionClaimsImg from 'assets/images/table/NoPendingDispositionClaimsImg.svg?react'
import { UserPreferencesKeysEnum } from 'features/settings/settingsTypes'
import moment from 'moment-timezone'
import {
  FaCaretDown,
  FaCheckSquare,
  FaCircleNotch,
  FaDownload,
  FaEllipsisV,
  FaFileUpload,
  FaTimesCircle,
} from 'react-icons/fa'
import { MdOutlineAccessTimeFilled } from 'react-icons/md'
import { Badge, Button, DownloadDropdown, OBDropdown, Tooltip, ObModal } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { PositionEnum } from 'types/cssTypes'
import { getFileName } from 'utils/helper'
import { notificator } from 'utils/notificator/notificator'

import { ObGrid } from '@outbound-ai/ursa'
import { useState } from 'react'
import {
  downloadUnmatchedEOB,
  downloadUnmatchedServiceLineItems,
  downloadUnSupportedFax,
  exportBatch,
  exportBatchClaims,
  exportBatchClaimsZip,
  exportLineItem,
  getPreSignedUrl,
  upgradeBatchwithAutoCheck,
} from '../autoCheckApi'
import {
  BatchProcessingStatus,
  BatchStatus,
  BatchTabType,
  BatchType,
  IdownloadCSV,
  ValidationDownloadEnum,
  ValidationDownloadType,
} from '../types'
import { createBatchServerSideDataSource } from './grid'
import { isBatchQueued, isOldBatchRecord } from './helper'
import { BatchTooltipText } from './tootlTipText'

export interface IprocessingStatus {
  [key: number]: {
    label: string
    type: any
    verbage?: string
    icon?: any
  }
}

export const processingStatusMap: IprocessingStatus = {
  0: {
    label: 'Initializing',
    type: 'default',
    icon: <MdOutlineAccessTimeFilled />,
  },
  1: {
    label: 'Queued',
    type: 'default',
    icon: <MdOutlineAccessTimeFilled />,
  },
  2: {
    label: 'Validating',
    type: 'default',
    icon: <MdOutlineAccessTimeFilled />,
  },
  3: {
    label: 'Completed',
    type: 'default',
    verbage: 'on',
    icon: <FaCheckSquare />,
  },
  4: {
    label: 'Failed to Complete',
    type: 'default',
    icon: <FaTimesCircle />,
  },
  5: {
    label: 'Canceled',
    type: 'default',
    icon: <FaTimesCircle />,
  },
  6: {
    label: 'Canceling',
    type: 'default',
    icon: <FaCircleNotch />,
  },
  7: {
    label: 'Pending Approval',
    type: 'default',
    icon: <MdOutlineAccessTimeFilled />,
  },
  8: {
    label: 'Uploading Claims',
    type: 'default',
    icon: <FaCircleNotch />,
  },
  9: {
    label: 'AutoCheck in Queue',
    type: 'default',
    icon: <MdOutlineAccessTimeFilled />,
  },
  10: {
    label: 'Ready for Processing',
    type: 'default',
    icon: <MdOutlineAccessTimeFilled />,
  },
  11: {
    label: 'AutoCheck in Progress',
    type: 'default',
    icon: <FaCircleNotch />,
  },
  12: {
    label: 'Validation Completed',
    type: 'default',
    icon: <MdOutlineAccessTimeFilled />,
  },
  13: {
    label: 'Awaiting EOBs',
    type: 'default',
    verbage: 'since',
    icon: <MdOutlineAccessTimeFilled />,
  },
  14: {
    label: 'Validation Failed',
    type: 'default',
    icon: <MdOutlineAccessTimeFilled />,
  },
}

export const FormatTime = (value: string | number | Date) => {
  if (!value) {
    return '---'
  }
  return (
    moment(value).local().format('MM/DD/YYYY') +
    ' at ' +
    moment(value).local().format('hh:mm a') +
    ' ' +
    moment(value).tz(moment.tz.guess()).zoneAbbr()
  )
}

export const FormatTimeDate = (value: string | number | Date) => {
  if (!value) {
    return '---'
  }
  return (
    moment(value).local().format('MM/DD/YYYY') +
    ' at ' +
    moment(value).local().format('hh:mm a') +
    ' ' +
    moment(value).tz(moment.tz.guess()).zoneAbbr()
  )
}

export const FormatTimeMonth = (value: string | number | Date) => {
  return (
    moment(value).local().format('MMM DD, YYYY') +
    ' ' +
    moment(value).local().format('hh:mm a').toUpperCase() +
    ' ' +
    moment(value).tz(moment.tz.guess()).zoneAbbr()
  )
}

export const downloadFile = (downloadData: IdownloadCSV) => {
  const blob = new Blob([downloadData.data], { type: downloadData.fileType })
  const a = document.createElement('a')
  a.download = downloadData.fileName
  a.href = window.URL.createObjectURL(blob)
  const clickEvt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  })
  a.dispatchEvent(clickEvt)
  a.remove()
}

export const handelDownload = (params: any) => {
  params.api.showLoadingOverlay()
  exportBatch(params.data.batchId)
    .then((res) => {
      if (res) {
        const downloadData: IdownloadCSV = {
          data: res,
          fileName: 'AutoCheckResult_BatchId_' + params.data.batchCode + '.csv',
          fileType: 'text/csv',
        }
        params.api.hideOverlay()
        downloadFile(downloadData)
      }
    })
    .catch(() => {
      params.api.hideOverlay()
      notificator.notify({
        type: 'error',
        heading: 'The operation has failed. Please try again later, and contact support if the problem persists.',
      })
    })
}

export const handleDownloadLineItem = (params: any) => {
  params.api.showLoadingOverlay()

  exportLineItem(params.data.batchId)
    .then((res) => {
      if (res) {
        const downloadData: IdownloadCSV = {
          data: res,
          fileName: 'ServiceLineItemsdetails_BatchId_' + params.data.batchCode + '.csv',
          fileType: 'text/csv',
        }
        params.api.hideOverlay()
        downloadFile(downloadData)
      }
    })
    .catch(() => {
      params.api.hideOverlay()
      notificator.notify({
        type: 'error',
        heading: 'The operation has failed. Please try again later, and contact support if the problem persists.',
      })
    })
}

export const handelDownloadZip = (params: any) => {
  params.api.showLoadingOverlay()

  exportBatchClaimsZip(params.data.batchId)
    .then((res) => {
      if (res) {
        const downloadData: IdownloadCSV = {
          data: res.data,
          fileName: getFileName(res.headers),
          fileType: 'application/zip',
        }
        params.api.hideOverlay()
        downloadFile(downloadData)
      }
    })
    .catch(() => {
      params.api.hideOverlay()
      notificator.notify({
        type: 'error',
        heading: 'The operation has failed. Please try again later, and contact support if the problem persists.',
      })
    })
}

export const handelDownloadUnmatchedEOB = (params: any) => {
  params.api.showLoadingOverlay()
  const currentPreferredTenant = sessionStorage.getItem(UserPreferencesKeysEnum.outboundAiPreferredTenant)

  const query = `tenantOwner=${currentPreferredTenant}&unmatchedDate=${moment(params.data.unmatchedDate)
    .utc()
    .format('YYYY-MM-DD')}`
  downloadUnmatchedEOB(query)
    .then((res) => {
      if (res) {
        const downloadData: IdownloadCSV = {
          data: res,
          fileName: params.data.fileName,
          fileType: 'application/zip',
        }

        params.api.hideOverlay()
        downloadFile(downloadData)
      }
    })
    .catch(() => {
      params.api.hideOverlay()
      notificator.notify({
        type: 'error',
        heading: 'The operation has failed. Please try again later, and contact support if the problem persists.',
      })
    })
}

export const handelDownloadUnSupportedFax = (params: any) => {
  params.api.showLoadingOverlay()
  const currentPreferredTenant = sessionStorage.getItem(UserPreferencesKeysEnum.outboundAiPreferredTenant)

  const query = `tenantOwner=${currentPreferredTenant}&dateReceived=${moment(params.data.dateReceived)
    .utc()
    .format('YYYY-MM-DD')}`
  downloadUnSupportedFax(query)
    .then((res) => {
      if (res) {
        const downloadData: IdownloadCSV = {
          data: res,
          fileName: params.data.fileName,
          fileType: 'application/zip',
        }

        params.api.hideOverlay()
        downloadFile(downloadData)
      }
    })
    .catch(() => {
      params.api.hideOverlay()
      notificator.notify({
        type: 'error',
        heading: 'The operation has failed. Please try again later, and contact support if the problem persists.',
      })
    })
}

export const handelBatchUpgrade = (params: any, batchType: BatchType) => {
  upgradeBatchwithAutoCheck(params.data.batchId, batchType)
    .then((res) => {
      if (res.status === 200) {
        notificator.notify({
          type: 'success',
          heading: 'Batch upgraded successfully',
        })
        const dataSource = createBatchServerSideDataSource(BatchTabType.Claims)
        params.api.setGridOption('serverSideDatasource', dataSource)
      }
    })
    .catch((err) => {
      notificator.notify({
        type: 'error',
        heading: err.response?.data.detail,
      })
    })
}

export const handelValidationDownload = (params: any, type: ValidationDownloadType) => {
  let downloadName = ''
  if (type === ValidationDownloadEnum.full) {
    downloadName = 'All_Claims_BatchId_' + params.data.batchCode + '.csv'
  } else if (type === ValidationDownloadEnum.errorOnly) {
    downloadName = 'Excluded_Claims_BatchId_' + params.data.batchCode + '.csv'
  } else if (type === ValidationDownloadEnum.successOnly) {
    downloadName = 'Validation_results_BatchId_' + params.data.batchCode + '.csv'
  }
  exportBatchClaims(params.data.batchId, type).then((res) => {
    if (res) {
      const downloadData: IdownloadCSV = {
        data: res.data,
        fileName: downloadName,
        fileType: 'text/csv',
      }
      downloadFile(downloadData)
    }
  })
}

export const handelDownloadServiceLineItem = (params: any) => {
  params.api.showLoadingOverlay()
  const currentPreferredTenant = sessionStorage.getItem(UserPreferencesKeysEnum.outboundAiPreferredTenant)

  const query = `tenantOwner=${currentPreferredTenant}&unmatchedDate=${moment(params.data.unmatchedDate)
    .utc()
    .format('YYYY-MM-DD')}`

  downloadUnmatchedServiceLineItems(query).then((res) => {
    if (res) {
      const downloadData: IdownloadCSV = {
        data: res,
        fileName: params.data.fileName.split('.')[0] + '.csv',
        fileType: 'text/csv',
      }
      params.api.hideOverlay()
      downloadFile(downloadData)
    }
  })
}

export const formatActionDownload = (params: any, root: any, batchPartView?: any) => {
  const recordCount = params.data.totalRecords
  const [showPartView, setShowPartView] = useState(false)
  //const [bathDetailsData, setBathDetailsData] = useState<any[]>([])
  const [selectedFiles, setSelectedFiles] = useState<any[]>([])

  /* const handelPartView = () => {
    getBatchEOBPartDetails(params.data.batchId, '')
      .then((res) => {
        if (res) {
          setBathDetailsData(res.data.eobPartFileList)
        }
      })
      .catch(() => {
        notificator.notify({
          type: 'error',
          heading: 'The operation has failed. Please try again later, and contact support if the problem persists.',
        })
      })
  } */

  const handelDownloadEOBPart = async (url: string, fileName: string, fileSize: number) => {
    try {
      const res = await getPreSignedUrl(url, '')
      if (res && res.data.url) {
        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        const downloadUrl = res.data.url + `&response-content-disposition=attachment; filename=${fileName} `
        iframe.src = downloadUrl
        document.body.appendChild(iframe)
        /**
         * Estimate the time needed to download based on:
         * - Assumed download speed = 1 MB/sec = 1,000,000 bytes/sec
         * - Browsers typically throttle to ~6 concurrent downloads
         *
         * So for queueing, if batchPartView.length > 6,
         * assume each batch of 6 downloads gets 1-second offset.
         */

        const numOfFileParts = batchPartView.length
        const batchSize = 6
        const assumedSpeedBytesPerMs = 1000000 / 1000 // 1 MB/sec = 1000 KB/sec = ~1000 bytes/ms
        const baseDownloadTimeMs = fileSize / assumedSpeedBytesPerMs

        // Calculate queuing delay due to browser concurrency limits (if more than 6 files)
        // const extraDelayMs = Math.floor(batchPartView.length / 6) * 1000

        // Estimate TTL
        let timeToLive = 0

        if (numOfFileParts === 1) {
          timeToLive = baseDownloadTimeMs * 2
        } else if (numOfFileParts <= batchSize) {
          timeToLive = baseDownloadTimeMs * 2 * Math.pow(1.1, numOfFileParts)
        } else {
          timeToLive = baseDownloadTimeMs * 2 * Math.pow(1.1, batchSize) * 3
        }

        // Add small buffer
        timeToLive += 1000

        setTimeout(() => {
          document.body.removeChild(iframe)
        }, timeToLive)
      }
    } catch {
      notificator.notify({
        type: 'error',
        heading: 'The operation has failed. Please try again later, and contact support if the problem persists.',
      })
    }
  }

  const downloadAllEOBParts = (data: any) => {
    const downloadPromises = data.map((item: any) => {
      return handelDownloadEOBPart(item.presignedURL, item.eobPartFileName, item.fileSize)
    })
    return Promise.all(downloadPromises)
  }

  const dropDownMenuItems = () => {
    const items: any[] = []

    // Validation Reports
    items.push({
      title: 'Validation Reports',
      items: [
        {
          text: 'All Claims (.csv)',
          onClick: () => handelValidationDownload(params, ValidationDownloadEnum.full),
          icon: <FaDownload />,
        },
        {
          text: 'Excluded Claims (.csv)',
          onClick: () => handelValidationDownload(params, ValidationDownloadEnum.errorOnly),
          icon: <FaDownload />,
        },
        {
          text: 'Validated Claims (.csv)',
          onClick: () => handelValidationDownload(params, ValidationDownloadEnum.successOnly),
          icon: <FaDownload />,
        },
      ],
    })

    // Processing Results
    items.push({
      title: 'Processing Results',
      items: [
        {
          text: 'Processing Results (.csv)',
          onClick: () => handelDownload(params),
          icon: <FaDownload />,
          disabled:
            !(root === BatchTabType.Processed || root === BatchTabType.EOB) ||
            parseInt(params.data.batchType) === BatchType.Claim_Import,
        },
        {
          text: 'Service Line-Items (.csv)',
          onClick: () => handleDownloadLineItem(params),
          icon: <FaDownload />,
          disabled: !(
            root === BatchTabType.Processed &&
            (parseInt(params.data.batchType) === BatchType.Claim_Autocheck_EOB ||
              parseInt(params.data.batchType) === BatchType.Claim_Autocheck)
          ),
        },
      ],
    })

    if (batchPartView && batchPartView.length > 0) {
      const eobItems = []

      if (batchPartView.length > 1) {
        eobItems.push({
          text: 'All EOB Zip Files',
          icon: <FaDownload />,
          onClick: () => downloadAllEOBParts(batchPartView),
        })
      }

      eobItems.push(
        ...batchPartView.map((item: any) => ({
          // EOBs BatchID 419 (2).zip to EOBs BatchID 419 - 2 (zip.)
          text: `${item.eobPartFileName.replace('.zip', ' (.zip)')}`,
          onClick: () => handelDownloadEOBPart(item.presignedURL, item.eobPartFileName, item.fileSize),
          disabled: !(
            root === BatchTabType.Processed &&
            parseInt(params.data.batchType) === BatchType.Claim_Autocheck_EOB &&
            parseInt(params.data.processingStatus) === BatchProcessingStatus.Complete &&
            params.data.eobReceivedCount !== 0
          ),
          icon: batchPartView.length > 1 ? '' : <FaDownload />,
          submenuStyle: batchPartView.length > 1 ? true : false,
        })),
      )

      items.push({
        title: 'Explanations of Benefits',
        items: eobItems,
      })
    }

    return items
  }

  return (
    <>
      <BatchDownload>
        {recordCount !== 0 && !isOldBatchRecord(params.data) && !isBatchQueued(params.data) ? (
          <>
            <DownloadDropdown
              buttonName={
                <>
                  Download <FaCaretDown />
                </>
              }
              items={dropDownMenuItems()}
            />
          </>
        ) : (
          <>
            <span className="action">
              <span className="download-disabled">
                <FaEllipsisV />
              </span>
            </span>
          </>
        )}
      </BatchDownload>
      <ObModal
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
            <span className="eob-file-parts-title">EOBs for Batch {params.data.batchCode}</span>
            <Button
              type="button"
              variant="primary-outline"
              size="small"
              radius="rounded"
              onClick={() => downloadAllEOBParts(selectedFiles)}
              disabled={selectedFiles.length === 0}
            >
              Download Selected
            </Button>
          </div>
        }
        size="lg"
        height="auto"
        show={showPartView}
        close={() => setShowPartView(false)}
      >
        <div className="eob-file-parts" style={{ maxHeight: '50vh', overflowY: 'auto' }}>
          {batchPartView && batchPartView.length > 0 ? (
            <ObGrid
              reactiveCustomComponents={true}
              columnDefs={
                [
                  /* checkbox selection column */
                  {
                    headerName: '',
                    field: 'checkboxSelection',
                    width: 40,
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    headerCheckboxSelectionFilteredOnly: true,
                    headerComponentParams: {
                      template: `<span class="ag-input-field-input ag-checkbox-input"></span>`,
                      innerRenderer: BatchSelectionHeader,
                    },
                  },

                  { field: 'eobPartFileName', headerName: 'File Name', flex: 1, minWidth: 150 },
                  { field: 'eobCount', headerName: 'EOB Count', width: 100 },
                  {
                    field: 'fileSize',
                    headerName: 'File Size',
                    width: 120,
                    valueFormatter: (params: any) => (params.value / (1024 * 1024)).toFixed(2) + ' MB',
                  },
                  {
                    field: 'presignedURL',
                    headerName: 'Download',
                    width: 100,
                    cellRendererFramework: (params: any) => (
                      <Button
                        type="button"
                        variant="primary-outline"
                        size="small"
                        width="50px"
                        radius="rounded"
                        onClick={() =>
                          handelDownloadEOBPart(
                            params.data.presignedURL,
                            params.data.eobPartFileName,
                            params.data.fileSize,
                          )
                        }
                      >
                        <FaDownload />
                      </Button>
                    ),
                  },
                ] as any
              }
              onGridReady={async (params: any) => {
                setTimeout(() => {
                  params.api.sizeColumnsToFit()
                }, 100)
              }}
              rowData={batchPartView}
              pagination={false}
              rowHeight={40}
              domLayout="autoHeight"
              rowSelection="multiple"
              onSelectionChanged={(params: any) => {
                const selectedRows = params.api.getSelectedRows()
                setSelectedFiles(selectedRows)
              }}
              className="ag-theme-alpine"
              key={showPartView ? 'open' : 'closed'}
            />
          ) : (
            <p>No EOB file parts available.</p>
          )}
        </div>
      </ObModal>
    </>
  )
}

export const BatchSelectionHeader = (params: any) => {
  return (
    <Div>
      <input
        type="checkbox"
        name="batchHeaderSelect"
        id="selectGridHeader"
        className="ag-input-field-input ag-checkbox-input"
        value="selectAll"
        onClick={(event: any) => {
          const startIndex = params.api.paginationProxy.getPageFirstRow()
          const endIndex = params.api.paginationProxy.getPageLastRow()
          if (event.target.checked) {
            params.api.forEachNode((node: any) => {
              if (node.rowIndex >= startIndex && node.rowIndex <= endIndex) {
                node.setSelected(true)
              } else {
                node.setSelected(false)
              }
            })
          } else {
            params.api.forEachNode((node: any) => node.setSelected(false))
          }
        }}
      />
    </Div>
  )
}

export const formatDownloadUnmatchedEOB = (params: any) => {
  return (
    <Div>
      {/* <Button
        type="button"
        variant="primary-outline"
        size="small"
        radius="rounded"
        onClick={() => handelDownloadUnmatchedEOB(params)}
      >
        Download <FaDownload />
      </Button> */}

      <OBDropdown
        size="small"
        variant="primary-outline"
        radius="rounded"
        className="eob-review-download"
        buttonName={
          <>
            <FaDownload /> Download
          </>
        }
        items={[
          {
            items: [
              {
                text: 'Unmatched EOBs (.zip)',
                onClick: () => handelDownloadUnmatchedEOB(params),
                icon: <FaDownload className="fa-download" />,
              },
              {
                text: 'Service Line-Items (.csv)',
                onClick: () => handelDownloadServiceLineItem(params),
                icon: <FaDownload className="fa-download" />,
              },
            ],
          },
        ]}
      />
    </Div>
  )
}

export const formatDownloadUnSupportedFax = (params: any) => {
  return (
    <Div>
      <Button
        type="button"
        variant="primary-outline"
        size="small"
        radius="rounded"
        onClick={() => handelDownloadUnSupportedFax(params)}
      >
        Download <FaDownload />
      </Button>
    </Div>
  )
}

export const getCount = (params: any) => {
  return params.data.batchType === BatchType.Claim_Import ? params.data.batchCount : params.data.autocheckCount
}

export const NoContentFOrNoEOB = () => {
  return (
    <NoContentDiv data-testid="no-content-container">
      <NoPendingDispositionClaimsImg />
      <div className="details">
        <p data-testid="title" className="title">
          No EOBs received
        </p>
        {/* <p data-testid="message" className="message">
          To begin loading claims, click “Upload File”.
        </p> */}
      </div>
      {/*<div className="actions">
        <Link to={PathsEnum.batch}>
          <Button variant="primary" size="large" radius="normal">
            Upload Claims File
          </Button>
        </Link>
  </div>*/}
    </NoContentDiv>
  )
}

export const NoContent = () => {
  return (
    <NoContentDiv data-testid="no-content-container">
      <NoPendingDispositionClaimsImg />
      <div className="details">
        <p data-testid="title" className="title">
          No claim batches yet
        </p>
        <p data-testid="message" className="message">
          To begin loading claims, click “Upload File”.
        </p>
      </div>
      {/*<div className="actions">
        <Link to={PathsEnum.batch}>
          <Button variant="primary" size="large" radius="normal">
            Upload Claims File
          </Button>
        </Link>
  </div>*/}
    </NoContentDiv>
  )
}

export const FormatStatus = (value: string) => {
  if (parseInt(value) === BatchStatus.Complete) {
    return (
      <Div>
        <Badge variant="tag" fill="light" type="success">
          Completed
        </Badge>
      </Div>
    )
  } else if (parseInt(value) === BatchStatus.FailedToComplete) {
    return (
      <Div>
        <Badge variant="tag" fill="light" type="danger">
          Failed To Complete
        </Badge>
      </Div>
    )
  } else if (parseInt(value) === BatchStatus.Canceled) {
    return (
      <Div>
        <Badge variant="tag" fill="light" type="danger">
          Canceled
        </Badge>
      </Div>
    )
  } else if (parseInt(value) === BatchStatus.InProgress) {
    return (
      <Div>
        <Badge variant="tag" fill="light" type="info">
          In Progress
        </Badge>
      </Div>
    )
  } else if (parseInt(value) === BatchStatus.Queued) {
    return (
      <Div>
        <Badge variant="tag" fill="light" type="info">
          Queued
        </Badge>
      </Div>
    )
  } else if (parseInt(value) === BatchStatus.Canceling) {
    return (
      <Div>
        <Badge variant="tag" fill="light" type="danger">
          Canceling
        </Badge>
      </Div>
    )
  } else if (parseInt(value) === BatchStatus.WaitingUserAction) {
    return (
      <Div>
        <Badge variant="tag" fill="light" type="info">
          Waiting for User Action
        </Badge>
      </Div>
    )
  } else if (parseInt(value) === BatchStatus.ValidationFailed) {
    return (
      <Div>
        <Badge variant="tag" fill="light" type="danger">
          Validation Failed
        </Badge>
      </Div>
    )
  }
}

export const formatBatchType = (value: string) => {
  if (parseInt(value) === BatchType.Claim_Import) {
    return (
      <BatchDetail>
        <Tooltip
          tooltipText={BatchTooltipText.importOnly}
          position={PositionEnum.bottom}
          tooltipStyles={{ 'min-width': '17rem', transform: 'translateY(36%) translateX(-32%)' }}
          positionContent={80}
          positionTooltipArrow={10}
        >
          <Badge variant="tag" type="info">
            <FaFileUpload /> Import Only
          </Badge>
        </Tooltip>
      </BatchDetail>
    )
  } else if (parseInt(value) === BatchType.Claim_Autocheck) {
    return (
      <BatchDetail>
        <Tooltip
          tooltipText={BatchTooltipText.autoCheck}
          position={PositionEnum.bottom}
          tooltipStyles={{ 'min-width': '15rem', transform: 'translateY(54%) translateX(-20%)' }}
          positionContent={80}
          positionTooltipArrow={10}
        >
          <Badge variant="tag" type="success">
            <img src={CustomRobotGreen} /> ECS
          </Badge>
        </Tooltip>
      </BatchDetail>
    )
  } else if (parseInt(value) === BatchType.Claim_Autocheck_EOB) {
    return (
      <BatchDetail>
        <Tooltip
          tooltipText={BatchTooltipText.awaitingEOB}
          position={PositionEnum.bottom}
          tooltipStyles={{ 'min-width': '15rem', transform: 'translateY(54%) translateX(-35%)' }}
          positionContent={80}
          positionTooltipArrow={10}
        >
          <Badge variant="tag" type="success">
            <img src={CustomRobotGreen} /> ECS + EOBs
          </Badge>
        </Tooltip>
      </BatchDetail>
    )
  } else if (parseInt(value) === BatchType.Claim_ASC) {
    return (
      <BatchDetail>
        <Tooltip
          tooltipText={BatchTooltipText.claimASC}
          position={PositionEnum.bottom}
          tooltipStyles={{ 'min-width': '15rem', transform: 'translateY(54%) translateX(-20%)' }}
          positionContent={80}
          positionTooltipArrow={10}
        >
          <Badge variant="tag" type="info">
            <FaFileUpload /> ASC
          </Badge>
        </Tooltip>
      </BatchDetail>
    )
  }
}

const BatchDetail = styled.span``

const BatchDownload = styled.div`
  position: relative;

  /* Target DownloadDropdown's dropdown menu - override z-index from DownloadDropdown component */
  > div .dropdown-menu.show,
  > div .dropdown-menu,
  .dropdown-menu.show,
  .dropdown-menu {
    position: fixed !important;
    z-index: 1055 !important;
  }
`

const Div = styled.div`
  display: flex;

  .icon-holder {
    svg {
      color: ${({ theme }) => theme.colors.grey.light};
    }
  }

  .action-button {
    background-color: transparent;
    border: none;
    svg {
      color: ${({ theme }) => theme.colors.info.dark};
    }
  }

  .action-button:disabled {
    svg {
      color: ${({ theme }) => theme.colors.grey.light};
    }
  }

  #selectGridHeader {
    width: 20px;
    height: 20px;
  }

  .warning-gap {
    margin-right: 0.5rem;
    svg {
      color: ${({ theme }) => theme.colors.error.dark};
    }
  }
  .download-disabled {
    color: ${({ theme }) => theme.colors.grey.light};
    padding: 0px 11px;
    font-size: 1.2rem;
  }
  .button-holder {
    display: inline-flex !important;
    gap: 10px !important;
    margin-left: 108px !important;
  }
  .actions-button-cell {
    overflow: visible;
  }
  span {
    ${({ theme }) => theme.typography.s.normal};
  }
  .total svg {
    color: ${({ theme }) => theme.colors.success.darker};
    margin-right: 0.2rem;
  }
  .dropstart svg {
    color: ${({ theme }) => theme.colors.primary.darker};
  }
  .auto svg {
    color: ${({ theme }) => theme.colors.info.darker};
    margin-right: 0.2rem;
  }
  .stop-processing {
    border-radius: 8px;
    padding: 0.5rem 0.5rem;
    border: solid 1px #d53f3f;
    background-color: #fff;
    font-size: 0.8rem;
    position: relative;
    color: #d53f3f;
    cursor: pointer;
  }
  .stop-processing-disabled {
    border-radius: 8px;
    padding: 0.5rem 0.5rem;
    border: solid 1px ${({ theme }) => theme.colors.grey.dark};
    background-color: ${({ theme }) => theme.colors.grey.lightest};
    font-size: 0.8rem;
    position: relative;
    color: ${({ theme }) => theme.colors.grey.dark};
  }
  .stop-processing:hover {
    background-color: ${({ theme }) => theme.colors.grey.lighter};
  }
  .download-icon {
    top: -0.2rem;
    position: relative;
    cursor: pointer;
  }
  .download-icon:hover {
    color: ${({ theme }) => theme.colors.grey.lightest};
    background-color: ${({ theme }) => theme.colors.primary.darker};
    padding: 0rem 0.2rem;
  }
  .bg {
    background-color: ${({ theme }) => theme.colors.info.lighter};
  }
  .download {
    border-radius: 8px;
    padding: 0.5rem 0.5rem;
    font-size: 0.8rem;
    position: relative;
    border: solid 1px #31457b;
    background-color: #fff;
    color: #31457b;
    cursor: pointer;
  }
  .download:hover {
    background-color: ${({ theme }) => theme.colors.grey.lighter};
  }

  .auto-check-btn {
    padding: ${({ theme }) => theme.spacing.xxs} ${({ theme }) => theme.spacing.xs};
    ${({ theme }) => theme.typography.s.medium};
  }
  .warning {
    color: ${({ theme }) => theme.colors.warning.neutral};
  }
  .error {
    color: ${({ theme }) => theme.colors.error.darker};
  }

  .eob-review-download .ob-dropdown .dropdown-menu {
    width: 18rem;
    transform: translate(1px, 36px) !important;
  }
  .eob-review-download .ob-dropdown .dropdown-menu .group-item {
    margin-bottom: 0 !important;
  }
  .eob-review-download .fa-download {
    color: ${({ theme }) => theme.colors.info.neutral};
  }

  /* .dropdown-menu.show {
    width: 217px;
  } */
  /* .btn-primary {
    background-color: transparent !important;
    border: transparent !important;
    color: ${({ theme }) => theme.colors.primary.darker};
  }
  .show > .btn-primary.dropdown-toggle {
    background-color: ${({ theme }) => theme.colors.primary.lighter} !important;
    border: transparent !important;
    color: ${({ theme }) => theme.colors.primary.darker};
  }
  .btn-primary:click {
    border: none !important;
    background-color: ${({ theme }) => theme.colors.primary.lighter} !important;
    color: ${({ theme }) => theme.colors.primary.darker};
  }
  .btn-primary:focus {
    border: none !important;
    background-color: ${({ theme }) => theme.colors.primary.lighter} !important;
    color: ${({ theme }) => theme.colors.primary.darker};
    box-shadow: none !important;
  }
  .btn-primary:hover {
    background-color: ${({ theme }) => theme.colors.primary.lighter} !important;
    border: transparent !important;
    color: ${({ theme }) => theme.colors.primary.darker};
  }
  .btn-primary::before {
    display: none;
  } */

  .batch_results {
    h4 {
      ${({ theme }) => theme.typography.h4.medium};
      color: ${({ theme }) => theme.colors.primary.neutral}!important;
    }
  }
`

const NoContentDiv = styled.div`
  position: absolute !important;
  inset: 0 0 0 0;
  height: 100%;
  width: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.25em;
  position: relative;
  top: -1em;
  margin-top: 2em;
  svg {
    width: ${({ theme }) => theme.util.pixelToRem(175)};
    height: 50%;
  }
  .details {
    max-width: 600px;
    white-space: pre-wrap;
    > .title {
      color: ${({ theme }) => theme.colors.primary.darker};
      ${({ theme }) => theme.typography.h5.bold};
      margin-top: 1.25;
    }
    > .message {
      ${({ theme }) => theme.typography.m.normal};
      color: ${({ theme }) => theme.colors.grey.darker};
    }
  }
`
